import {IOrderRuleMethodEntry} from "../../../../../../store/trafficManagement/orderRules/types";
import AutoAssignOrderRule, {defaultRulesAutoAssign, yupRulesAutoAssignSchema} from "./AutoAssignOrderRule";

export const orderRuleMethodsRegistry: Record<string, IOrderRuleMethodEntry> = {
    "auto--assign": {
        id: "auto--assign",
        label: "Auto Assign",
        Component: AutoAssignOrderRule,
        defaultRule: defaultRulesAutoAssign,
        yupRulesSchema: yupRulesAutoAssignSchema
    }
};

const methodsRegistryValidationMap = Object.entries(orderRuleMethodsRegistry)
    .map(([key, entry]) => [key, entry.yupRulesSchema])

export const orderRuleMethodSchemas = Object.fromEntries(methodsRegistryValidationMap) as {
    [K in keyof typeof orderRuleMethodsRegistry]: typeof orderRuleMethodsRegistry[K]["yupRulesSchema"]
};